import {Injectable} from '@angular/core';
import {ObbBuilder} from './obb-builder.service';

declare let THREE: any;

const getBorder = function (entity) {
  const border = entity.borders;
  return border && border.default ? parseFloat(border.default) : null;
};

const getWallGap = function (entity) {
  const border = entity.borders;
  return border && border.wall ? parseFloat(border.wall) : null;
};

const getSizeWithBorder = function (obj, border) {

  const entity = obj.userData.entity;

  const size = new THREE.Vector3();

  if (entity) {
    size.set(entity.length, entity.height, entity.width);
  } else if (obj.geometry) {
    if (!obj.geometry.boundingBox) {
      obj.geometry.computeBoundingBox();
    }
    obj.geometry.boundingBox.getSize(size);
  } else {
    new THREE.Box3().setFromObject(obj).getSize(size);
  }

  if (border) {
    size.addScalar(border);
  }

  return size;
};

interface Config {
  newPosition?: any;
  staticColliderCache?: object;
  newRotation?: any;
  useObjectScale?: boolean;
  newSize?: any;
}

@Injectable()
export class CollisionService {

  objectOBBIntersectWalls(objOBB, walls) {
    let i = 0,
      wall,
      wallOBB;

    for (; i < walls.length; i++) {
      wall = walls[i];
      wallOBB = new ObbBuilder().build(wall);
      if (objOBB.isIntersectionOBB(wallOBB)) {
        return wall;
      }
    }

    return null;
  }

  isCollide(draggedObject, staticObjs, config: Config = {}) {

    draggedObject.updateMatrixWorld();

    let i = 0,
      staticObj,
      staticObjEntity,
      currentOBB,
      staticObjectSize,
      staticObjOBB,
      border;

    const draggedObjectEntity = draggedObject.userData.entity;
    const {staticColliderCache, newSize, newRotation, useObjectScale, newPosition} = config;

    if (!Array.isArray(staticObjs)) {
      staticObjs = [staticObjs];
    }

    if (staticObjs && staticObjs.length !== 0) {

      currentOBB = new ObbBuilder()
        .setPosition(newPosition)
        .setSize(newSize || getSizeWithBorder(draggedObject, 0))
        .setRotation(newRotation)
        .useObjectScale(useObjectScale)
        .build(draggedObject);

      for (; i < staticObjs.length; i++) {

        staticObj = staticObjs[i];

        staticObj.updateMatrixWorld();

        staticObjEntity = staticObj.userData ? staticObj.userData.entity : null;

        border = (!staticObjEntity || staticObjEntity.isWall)
          ? getWallGap(draggedObjectEntity) : getBorder(staticObjEntity);

        if (staticColliderCache && staticColliderCache[staticObj.uuid]) {
          staticObjOBB = staticColliderCache[staticObj.uuid];
        } else {
          staticObjectSize = getSizeWithBorder(staticObj, border);

          staticObjOBB = new ObbBuilder()
            .setSize(staticObjectSize)
            .build(staticObj);

          if (staticColliderCache) {
            staticColliderCache[staticObj.uuid] = staticObjOBB;
          }
        }

        if (currentOBB.isIntersectionOBB(staticObjOBB)) {
          return staticObj;
        }

      }
    }

    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/collision/collision.service.ts